import axios from "axios";
import {
  addCaseFailure,
  addCaseStart,
  addCaseSuccess,
  getEnvoieFailure,
  getEnvoieStart,
  getEnvoieSuccess,
  getEnvoisFailure,
  getEnvoisStart,
  getEnvoisSuccess,
  setPageNumberSuccess,
} from "./EnvoieActions";
import { API_URL } from "../../config/runtimeConfig";

const axiosInstance = axios.create({
  baseURL: API_URL,
});

export const getHistories = async (dispatch, pageSize, page, tracking) => {
  let historyFilter = { tracking };
  dispatch(getEnvoisStart());
  try {
    const res = await axiosInstance.post(
      `/delivery/histories?pageSize=${pageSize}&page=${page}`,
      historyFilter,
      {
        headers: {
          token:
            `nweadmin ` + JSON.parse(localStorage.getItem("user")).accessToken,
        },
      },
    );
    dispatch(getEnvoisSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(getEnvoisFailure(err.response.data.message));
    } else {
      dispatch(getEnvoisFailure("Unkown Error"));
    }
  }
};

export const setPageNumber = (dispatch, page) => {
  dispatch(setPageNumberSuccess(page));
};

export const getHistory = async (dispatch, id) => {
  dispatch(getEnvoieStart());
  try {
    const res = await axiosInstance.get(`/delivery/histories/${id}`, {
      headers: {
        token:
          `nweadmin ` + JSON.parse(localStorage.getItem("user")).accessToken,
      },
    });
    dispatch(getEnvoieSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(getEnvoieFailure(err.response.data.message));
    } else {
      dispatch(getEnvoieFailure("Unkown Error"));
    }
  }
};

export const addHistoryCase = async (dispatch, type, motif, historyId) => {
  let historyCaseBody = { type, motif, historyId };
  dispatch(addCaseStart());
  try {
    const res = await axiosInstance.post(
      `/delivery/histories/add`,
      historyCaseBody,
      {
        headers: {
          token:
            `nweadmin ` + JSON.parse(localStorage.getItem("user")).accessToken,
        },
      },
    );
    dispatch(addCaseSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(addCaseFailure(err.response.data.message));
    } else {
      dispatch(addCaseFailure("Unkown Error"));
    }
  }
};
